import React, { Component } from 'react';
import { API_PATH} from './config.js';

class LosQueCrecen extends Component {
    constructor (props) {
        super(props)
        this.state = {
          loading: true,
          data:[],
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchcrecen();
        }, 100);
    }

    fetchcrecen = () => {
        fetch(API_PATH + "los_que_crecen?page=1&per_page=100")
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error en la respuesta del servidor');
                }
                return response.json();
            })
            .then(data => {
                this.setState({ data, loading: false });
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    Sanitize(title) {
        var rawMarkup = title;
        return { __html: rawMarkup };
    }
    render() {
        const { loading, data } = this.state;
        if (loading === true) {
            return(
                <div className="preloader" >
                    <div className="div-transform">
                        <div className="loader">
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <>
                <div className="container-fluid bg-black" >
                <h1 align="center" className="tituloPrincipal"><b>LOS <span className="title-white">QUE</span> crecen</b></h1>
                </div>
                <br/><br/>
                <div className='container'>
                    <div className='row'>
                        {data.map((crecen, index) => {
                            let nombre = crecen.title.rendered;
                            let puesto = crecen.acf.person_divition;
                            let foto = crecen.acf.foto;
                
                            return (
                                <div className="col-md-4 carousel-innersmall img__wrap" key ={index}>
                                    <div className="tile-slide-container">
                                        <img className="img-fluid" alt={puesto} src={foto} />
                                    </div>
                                    <div className="img__description">
                                        <div className="title">
                                            <h5>{puesto}</h5>
                                            <hr className="hrwhite" />
                                            <h3 className="title-carasvemos"  dangerouslySetInnerHTML={this.Sanitize(nombre)}></h3>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <br/><br/>
            </>
        )
    }
}
export default LosQueCrecen;